<template>
  <section class="card">
    <div class="card-body" :class="$style.divText">
      <h1><strong>Coming Soon!</strong></h1>
      <h2><strong>This page is under development.</strong></h2>
      <router-link to="/" class="btn">&larr; Go back to the home page</router-link>
    </div>
  </section>
</template>
<style lang="scss" module>
@import "./style.module.scss";

</style>
<script>
export default {
  data: function () {
    return {}
  },
}
</script>
